@if (isPeriodEnabled) {
  <div
    class="re-focus-keydown"
    [class]="colourClass"
    tabindex="0"
    (click)="openPdf()"
    (keydown.enter)="openPdf()">
    <img [src]="img.src" [alt]="img.alt" height="16" />
  </div>
} @else {
  <span
    ><strong>{{ periodLabel }} data is unavailable - </strong>We are currently updating this data,
    check back later for updates.</span
  >
}
